import { Box, Flex, Skeleton } from '@chakra-ui/react';
import { ReactElement } from 'react';

export const VideoCardSkeleton = (): ReactElement => (
  <Flex
    flexDir="column"
    gap="10px"
    border="default"
    borderColor="border.accent"
    borderRadius="10px"
    flexGrow={1}
    flexShrink={0}
    width="100%"
    minWidth="100%"
  >
    <Skeleton
      borderRadius="8px 8px 0 0"
      overflow="hidden"
      flexGrow={1}
      width="100%"
      height={{ base: '110px', md: '160px' }}
      maxHeight={{ base: '110px', md: '160px' }}
      position="relative"
    />
    <Box
      p="0 15px 15px 15px"
      flexGrow={1}
      width="100%"
      display="flex"
      flexDir="column"
      justifyContent="space-between"
    >
      <Skeleton height="20px" width="80%" mb="10px" />
      <Skeleton height="16px" width="60%" />
    </Box>
  </Flex>
);
